<template>
    <section>
        <nav-component :titulo="'Usuarios'" :link="can('usuarios.registrar') ? { path: '/agregar-usuario' } : null" :texto="'Agregar usuario'" />
        <mensaje-inicial :titulo="'No se han registrado usuarios'" :subtitulo="'Agrega algunos usuarios'" v-if="usuarios.length < 1" />
        <b-table
        :data="usuarios">
            <b-table-column field="usuario" label="Nombre de usuario" sortable searchable v-slot="props">
                {{ props.row.usuario }}
            </b-table-column>

            <b-table-column field="nombre" label="Nombre completo" sortable searchable v-slot="props">
                {{ props.row.nombre }}
            </b-table-column>

            <b-table-column field="telefono" label="Teléfono" sortable searchable v-slot="props">
                {{ props.row.telefono }}
            </b-table-column>

            <b-table-column field="eliminar" label="Eliminar" v-slot="props"
                v-if="can('usuarios.eliminar')">
                <b-button
                    v-if="props.row.id !== 1 && props.row.id !== miId"
                    type="is-danger" icon-left="delete" @click="eliminar(props.row)">Eliminar</b-button>
            </b-table-column>

            <b-table-column field="editar" label="Editar" v-slot="props" v-if="can('usuarios.editar')">
                <b-button type="is-info" icon-left="pen" @click="editar(props.row.id)">Editar</b-button>
            </b-table-column>
        </b-table>

        <div class="mt-4">
            <b-button type="is-warning" icon-left="eye" @click="abrirOcultos"
                v-if="can('usuarios.eliminar')">
                Usuarios eliminados
            </b-button>
        </div>

        <b-modal v-model="mostrarOcultos" has-modal-card trap-focus aria-role="dialog" aria-modal>
            <div class="modal-card" style="width: 90vw; max-width: 900px">
                <header class="modal-card-head has-background-warning">
                    <p class="modal-card-title has-text-white">Usuarios eliminados</p>
                    <button type="button" class="delete" @click="mostrarOcultos = false" />
                </header>
                <section class="modal-card-body">
                    <p v-if="cargandoOcultos" class="has-text-centered py-4">Cargando…</p>
                    <p v-else-if="usuariosOcultos.length === 0" class="has-text-centered has-text-grey py-4">
                        No hay usuarios eliminados.
                    </p>
                    <b-table v-else :data="usuariosOcultos" hoverable>
                        <b-table-column field="usuario" label="Usuario" v-slot="props">{{ props.row.usuario }}</b-table-column>
                        <b-table-column field="nombre" label="Nombre completo" v-slot="props">{{ props.row.nombre }}</b-table-column>
                        <b-table-column field="telefono" label="Teléfono" v-slot="props">{{ props.row.telefono }}</b-table-column>
                        <b-table-column field="rol" label="Rol" v-slot="props">{{ props.row.rol || '—' }}</b-table-column>
                        <b-table-column field="reactivar" label="Reactivar" v-slot="props">
                            <b-button type="is-success" size="is-small" icon-left="undo"
                                @click="reactivar(props.row)">Reactivar</b-button>
                        </b-table-column>
                    </b-table>
                    <p class="is-size-7 has-text-grey mt-3">
                        Al reactivar, el usuario vuelve a la lista y puede iniciar sesión con su misma contraseña.
                    </p>
                </section>
                <footer class="modal-card-foot">
                    <b-button label="Cerrar" @click="mostrarOcultos = false" />
                </footer>
            </div>
        </b-modal>
        <b-loading :is-full-page="true" v-model="cargando" :can-cancel="false"></b-loading>
    </section>
</template>
<script>
    import MensajeInicial from '../Extras/MensajeInicial'
    import NavComponent from '../Extras/NavComponent'
    import HttpService from '../../Servicios/HttpService'
    import AyudanteSesion from '../../Servicios/AyudanteSesion'

    export default {
        name: "UsuariosComponent",
        components: { MensajeInicial, NavComponent },

        data:()=>({
            cargando: false,
            usuarios: [],
            // Id del usuario con la sesion abierta: no debe poder eliminarse a si mismo.
            miId: AyudanteSesion.usuario()?.id ?? null,
            usuariosOcultos: [],
            mostrarOcultos: false,
            cargandoOcultos: false
        }),

        mounted(){
            this.obtenerUsuarios()
        },

        methods: {
            /**
             * El borrado es LOGICO: el usuario deja de poder entrar y desaparece de la lista,
             * pero sus facturas, cuentas, cotizaciones y cierres se conservan con su nombre.
             */
            eliminar(usuario){
                const nombre = this.escapar(usuario.nombre || usuario.usuario)
                const cuenta = this.escapar(usuario.usuario)

                this.$buefy.dialog.confirm({
                    title: 'Eliminar usuario',
                    message: `<b>${nombre}</b> (${cuenta})<br><br>`
                        + 'Dejará de aparecer en la lista y <b>no podrá iniciar sesión</b>.<br>'
                        + 'Su historial de ventas, cuentas, cotizaciones y cierres <b>se conserva</b> '
                        + 'y se sigue mostrando con su nombre.<br><br>¿Continuar?',
                    confirmText: 'Sí, eliminar',
                    cancelText: 'Cancelar',
                    type: 'is-danger',
                    hasIcon: true,
                    onConfirm: () => {
                        this.cargando = true
                        HttpService.eliminar('usuarios.php', {
                            accion: 'eliminar',
                            id: usuario.id
                        })
                        .then(resultado => {
                            if (resultado && resultado.success === true) {
                                this.$buefy.toast.open({
                                    type: 'is-info',
                                    message: resultado.mensaje || 'Usuario eliminado.'
                                })
                                this.obtenerUsuarios()
                            } else {
                                this.$buefy.toast.open({
                                    type: 'is-danger',
                                    message: (resultado && resultado.error) || 'Error al eliminar'
                                })
                            }
                        })
                        .catch(() => {
                            this.$buefy.toast.open({ type: 'is-danger', message: 'Error al eliminar' })
                        })
                        .finally(() => {
                            this.cargando = false
                        })
                    }
                })
            },

            /** Panel de usuarios eliminados (para poder reactivar si fue un error). */
            abrirOcultos(){
                this.mostrarOcultos = true
                this.cargandoOcultos = true

                HttpService.obtenerConConsultas('usuarios.php', { accion: 'obtener_ocultos' })
                    .then(lista => {
                        this.usuariosOcultos = Array.isArray(lista) ? lista : []
                    })
                    .catch(() => {
                        this.usuariosOcultos = []
                        this.$buefy.toast.open({ type: 'is-danger', message: 'No se pudo cargar la lista' })
                    })
                    .finally(() => {
                        this.cargandoOcultos = false
                    })
            },

            reactivar(usuario){
                this.$buefy.dialog.confirm({
                    title: 'Reactivar usuario',
                    message: `¿Reactivar a <b>${this.escapar(usuario.usuario)}</b>? Volverá a poder iniciar sesión.`,
                    confirmText: 'Sí, reactivar',
                    cancelText: 'Cancelar',
                    type: 'is-success',
                    hasIcon: true,
                    onConfirm: () => {
                        this.cargandoOcultos = true
                        HttpService.eliminar('usuarios.php', { accion: 'reactivar', id: usuario.id })
                            .then(resultado => {
                                if (resultado && resultado.success === true) {
                                    this.$buefy.toast.open({
                                        type: 'is-info',
                                        message: resultado.mensaje || 'Usuario reactivado.'
                                    })
                                    this.obtenerUsuarios()
                                    this.abrirOcultos()
                                } else {
                                    this.$buefy.toast.open({
                                        type: 'is-danger',
                                        message: (resultado && resultado.error) || 'No se pudo reactivar'
                                    })
                                }
                            })
                            .catch(() => {
                                this.$buefy.toast.open({ type: 'is-danger', message: 'No se pudo reactivar' })
                            })
                            .finally(() => {
                                this.cargandoOcultos = false
                            })
                    }
                })
            },

            /** Escapa texto para los mensajes HTML del diálogo (evita inyección). */
            escapar(valor){
                return String(valor ?? '').replace(/[&<>"']/g, (c) => (
                    { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]
                ))
            },

            editar(idUsuario){
                this.$router.push({
                    name: "EditarUsuario",
                    params: { id: idUsuario}
                })
            },

            obtenerUsuarios(){
                this.cargando = true
                let payload = {
                    accion: 'obtener'
                }
                HttpService.obtenerConConsultas('usuarios.php', payload)
                .then(usuarios => {
                    this.usuarios = usuarios
                    this.cargando = false
                })
            }
        }
    }
</script>
